import React from "react"
import ComponentWithData from "~/utils/ComponentWithData"

import {Location} from "~/utils/ShelfEntities"

import {
  List,
  DetailInfoRow,
  BarcodeDetailInfoRow,
  ListItemArea,
  Button
} from "~/components/"
import {ArticleList} from "../list/ArticleList"

import {withTranslation} from "react-i18next"

class LocationDetailView extends ComponentWithData {
  getData() {
    return Location.find(this.props.match.params.location_barcode)
  }
  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }
  renderError() {
    return (
      <p>
        {this.props.t("error")}. {console.log(this.state.error)}
      </p>
    )
  }
  renderEmpty() {
    return <p>{this.props.t("locations.noLocation")}</p>
  }
  renderWithData() {
    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">{this.props.t("locations.title")}</div>
          <div className="actions">
            <Button
              primary
              to={"/locations/" + this.state.data.barcode}
              label={this.props.t("edit")}
            />
          </div>
        </div>
        <div>
          <DetailInfoRow
            label={this.props.t("locations.detail.zone")}
            value={this.state.data.name}
          />

          <BarcodeDetailInfoRow value={this.state.data.barcode} />

          <DetailInfoRow label={this.props.t("locations.detail.zone")}>
            <List items={[this.state.data.area]} itemRenderer={ListItemArea}>
              <div className="empty">
                {this.props.t("locations.detail.noLocationInZone")}
              </div>
            </List>
          </DetailInfoRow>

          <DetailInfoRow
            label={this.props.t("locations.detail.stockedInArticles")}
          >
            <ArticleList
              filterByExpiryDate={false}
              locationId={this.state.data.id}
            />
          </DetailInfoRow>
        </div>
      </div>
    )
  }
}

export default withTranslation()(LocationDetailView)



// WEBPACK FOOTER //
// ./src/views/detail/LocationDetailView.js